module.exports = __webpack_public_path__ + "img/A.d00b8684.png";